export const LogoMark = ({ size = 40 }) => (
    <svg width={size} height={size} viewBox="0 0 64 64" aria-hidden="true">
        <rect width="64" height="64" rx="16" fill="#F8F6F0" />
        <g fill="#C85A32">
            <ellipse cx="32" cy="42" rx="11" ry="8.5" />
            <ellipse cx="16.5" cy="29" rx="4.6" ry="6" transform="rotate(-18 16.5 29)" />
            <ellipse cx="26" cy="21.5" rx="4.8" ry="6.4" transform="rotate(-6 26 21.5)" />
            <ellipse cx="38" cy="21.5" rx="4.8" ry="6.4" transform="rotate(6 38 21.5)" />
            <ellipse cx="47.5" cy="29" rx="4.6" ry="6" transform="rotate(18 47.5 29)" />
        </g>
        <path d="M10 55 Q18 51 26 55 T42 55 T58 55" stroke="#4A5D3E" strokeWidth="3" fill="none" strokeLinecap="round" />
    </svg>
);

const Logo = ({ compact = false }) => (
    <span className="flex items-center gap-2.5" data-testid="brand-logo">
        <LogoMark size={compact ? 34 : 40} />
        <span className="leading-none">
            <span className="font-serif block text-[22px] font-bold italic tracking-tight text-ink">
                Maresme
            </span>
            <span className="block text-[10px] font-bold uppercase tracking-[0.3em] text-olive">
                Dog Care
            </span>
        </span>
    </span>
);

export default Logo;
